"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ignore = void 0;
/**
 * Utility for ignoring certain errors and returning a default value.
 *
 * @param errorClasses
 */
function ignore(...errorClasses) {
    return function createIgnoreFn(valToReturnOnCatch) {
        return function ignoreImpl(err) {
            if (errorClasses.some((C) => err instanceof C)) {
                return valToReturnOnCatch;
            }
            throw err;
        };
    };
}
exports.ignore = ignore;
//# sourceMappingURL=ignore.js.map